import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { KakoCoin } from '../oil/OilIcons';
import { fmt } from './wbApi';
import { wbSfx } from './wbSfx';

/* Card do resultado (estilo Hongbao): o servidor já decidiu — aqui só a revelação. */
export const WbPopResult = ({ pop, balance, popCost, onAgain, onClose, onRecharge }) => {
  const prize = Number(pop?.prize || 0);
  const big = pop?.result === 'WIN_BIG';
  useEffect(() => { if (prize > 0) { wbSfx.candy(); setTimeout(() => wbSfx.coin(), 400); } else wbSfx.empty(); }, [prize]);
  const podeDeNovo = Number(balance || 0) >= Number(popCost || 500);
  return createPortal(
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm" data-testid="wb-pop-result" onClick={onClose}>
      <div className={`wb-reveal-item relative w-full max-w-sm overflow-hidden rounded-3xl border p-5 text-center ${big ? 'border-amber-300 bg-gradient-to-b from-amber-700 via-amber-900 to-[#1a0b00]' : prize > 0 ? 'border-orange-400/70 bg-gradient-to-b from-orange-800 to-[#1a0b00]' : 'border-purple-700/70 bg-gradient-to-b from-[#2a1540] to-[#0a0612]'}`}
        onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute right-3 top-3 rounded-full bg-black/40 p-1.5 text-white/70" data-testid="wb-pop-close" aria-label="Fechar"><X className="h-4 w-4" /></button>
        <img src={prize > 0 ? '/wb/witch_cheer.webp' : '/wb/witch_scared.webp'} alt="" className="mx-auto -mt-1 h-28 object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,.7)]" />
        <p className="wb-title mt-1 text-3xl text-orange-300" data-testid="wb-pop-result-title">
          {big ? 'BALÃO DOURADO!' : prize > 0 ? 'ESTOUROU E CAIU PRÊMIO!' : 'BALÃO VAZIO…'}
        </p>
        {prize > 0 ? (
          <div className="mt-2 flex items-center justify-center gap-2 text-3xl font-black text-amber-200" data-testid="wb-pop-prize">
            <KakoCoin className="h-8" /> +{fmt(prize)} <span className="text-sm text-amber-400/80">moedas</span>
          </div>
        ) : (
          <p className="mt-2 text-sm text-purple-200/80" data-testid="wb-pop-empty">Nada desta vez. O próximo pode ser o dourado!</p>
        )}
        {prize > 0 && <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-emerald-300">moedas a caminho da sua conta KAKO</p>}
        <p className="mt-3 text-[11px] text-purple-200/80" data-testid="wb-pop-balance">Saldo: <b className="text-amber-300">{fmt(balance)}</b> Moedas da Bruxa</p>
        {podeDeNovo ? (
          <button onClick={onAgain} className="wb-btn-collect mt-3" data-testid="wb-pop-again">Estourar outro ({fmt(popCost)})</button>
        ) : (
          <button onClick={onRecharge} className="wb-btn-collect mt-3" data-testid="wb-pop-recharge">Recarregar e ganhar mais</button>
        )}
      </div>
    </div>, document.body);
};
